import { ACTION_CLEAR_ITEM_FOR_OPTION_MODE } from './types';

const clearItemForOptionMode = () => ({
  type: ACTION_CLEAR_ITEM_FOR_OPTION_MODE,
});

export default clearItemForOptionMode;
